"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeInfoRpcRemote = void 0;
const dht_1 = require("@streamr/dht");
class NodeInfoRpcRemote extends dht_1.RpcRemote {
    async getInfo() {
        return this.getClient().getInfo({}, this.formDhtRpcOptions());
    }
}
exports.NodeInfoRpcRemote = NodeInfoRpcRemote;
//# sourceMappingURL=NodeInfoRpcRemote.js.map